import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctValue } from '../../../../Fct/generics';
import { ROUTER_ADDRESSES } from '../constants';
export var GetAmountsOut = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'GETTER',
    method: 'getAmountsOut',
    supportedContracts: ROUTER_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_router' }),
            methodParams: {
                amountIn: new FctValue({}),
                path: new FctAddressList({}),
            },
        },
        output: {
            amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
        },
    }); },
});
